import React, { ReactElement } from 'react';
import { ListRenderer } from '@feast-it/ui/light';

import { TestimonialQuote } from '../../../components/TestimonialQuote';
import { GridWrapper, StyledHeading, Wrapper } from './Reviews.styled';
import { SliceLayout } from '../../../components/SliceLayout';

export type Review = {
  image: {
    filename?: string;
    key?: string;
    url: string;
  };
  eventType: string;
  supplierName: string;
  supplierSlug: string;
  author: string;
  quote: string;
  rating: number;
};

interface ReviewsProps {
  reviews: Review[];
}

export function Reviews({ reviews }: ReviewsProps): ReactElement {
  return (
    <SliceLayout backgroundColor="lightGrey">
      <Wrapper>
        <StyledHeading as="h2" style="headingMobileExtraLarge" color="black">
          What do our customers think?
        </StyledHeading>

        <GridWrapper>
          <ListRenderer
            items={reviews}
            render={({ item }) => <TestimonialQuote review={item} />}
          />
        </GridWrapper>
      </Wrapper>
    </SliceLayout>
  );
}
